// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanOmnibusBalanceBreakdownRecordDto
 */
export interface IPlanOmnibusBalanceBreakdownRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    plan_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    plan_start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    plan_end_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    transaction_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    activity_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    memo?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IPlanOmnibusBalanceBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IPlanOmnibusBalanceBreakdownRecordDto interface.
 */
export function instanceOfIPlanOmnibusBalanceBreakdownRecordDto(value: object): value is IPlanOmnibusBalanceBreakdownRecordDto {
    return true;
}

export function IPlanOmnibusBalanceBreakdownRecordDtoFromJSON(json: any): IPlanOmnibusBalanceBreakdownRecordDto {
    return IPlanOmnibusBalanceBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IPlanOmnibusBalanceBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanOmnibusBalanceBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_type': json['plan_type'] == null ? undefined : json['plan_type'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'plan_start_date': json['plan_start_date'] == null ? undefined : (new Date(json['plan_start_date'])),
        'plan_end_date': json['plan_end_date'] == null ? undefined : (new Date(json['plan_end_date'])),
        'transaction_date': json['transaction_date'] == null ? undefined : (new Date(json['transaction_date'])),
        'activity_type': json['activity_type'] == null ? undefined : json['activity_type'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IPlanOmnibusBalanceBreakdownRecordDtoToJSON(json: any): IPlanOmnibusBalanceBreakdownRecordDto {
    return IPlanOmnibusBalanceBreakdownRecordDtoToJSONTyped(json, false);
}

export function IPlanOmnibusBalanceBreakdownRecordDtoToJSONTyped(value?: IPlanOmnibusBalanceBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_type': value['plan_type'],
        'plan_name': value['plan_name'],
        'plan_code': value['plan_code'],
        'plan_year': value['plan_year'],
        'plan_start_date': value['plan_start_date'] == null ? undefined : ((value['plan_start_date']).toISOString().substring(0,10)),
        'plan_end_date': value['plan_end_date'] == null ? undefined : ((value['plan_end_date']).toISOString().substring(0,10)),
        'transaction_date': value['transaction_date'] == null ? undefined : ((value['transaction_date']).toISOString()),
        'activity_type': value['activity_type'],
        'memo': value['memo'],
        'amount': value['amount'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

